export default __webpack_public_path__ + "static/media/sample-video.8d76a10d.mp4";